const sv = {
  // Navigation and General
  companyRegistration: 'Företagsregistrering',
  previous: 'Föregående',
  continue: 'Fortsätt',
  submitRegistration: 'Skicka in registrering',
  reset: 'Återställ',

  // Form Steps
  information: 'Information',
  companyInfo: 'Kontaktperson',
  companyInformation: 'Bolagsuppgifter',
  contact: 'Räkenskapsår',
  businessDetails: 'Företrädare',
  confirmation: 'Firmateckning',
  bankAndAuth: 'Bank och fullmakter',
  reservations: 'Förbehåll',
  auditor: 'Revisor',
  otherInfo: 'Övriga uppgifter',

  // Step Indicators
  step: 'Steg',
  of: 'av',

  // Information Step
  informationStepTitle: 'Välkommen till företagsregistreringsguiden',
  wizardOverview:
    'Denna steg-för-steg guide kommer att leda dig genom hela företagsregistreringsprocessen.',
  registrationProcess: 'Översikt av registreringsprocessen',
  processSteps: 'Du kommer att slutföra följande steg:',
  stepContactPerson: '1. Kontaktpersonsinformation',
  stepCompanyInfo: '2. Bolagsuppgifter',
  stepFinancialYear: '3. Räkenskapsår',
  stepRepresentatives: '4. Företrädare',
  stepCompanySignature: '5. Firmateckning',
  stepOtherInfo: '6. Övriga uppgifter',
  costInformation: 'Kostnadsinformation',
  pdfCost: 'Kostnad för PDF-generering: 399 SEK ex. moms',
  costDescription:
    'Denna avgift täcker bearbetning och generering av ditt officiella PDF-dokument för företagsregistrering.',
  whatYouReceive: 'Vad du kommer att få',
  receiveItems: 'Vid slutförande och betalning kommer du att få:',
  officialPdf: 'Ett officiellt PDF-dokument med din företagsregistreringsinformation',
  invoiceDocument: 'En detaljerad faktura för de tillhandahållna tjänsterna',
  deliveryMethod: 'Båda dokumenten kommer att skickas till din angivna e-postadress.',
  getStarted: 'Redo att komma igång? Klicka "Fortsätt" för att påbörja registreringsprocessen.',

  // Toast Messages
  registrationSubmitted: 'Registreringsformuläret har skickats in!',
  pleaseCompleteAllFields: 'Vänligen fyll i alla obligatoriska fält innan du skickar in.',
  pleaseConfirmSubmission:
    'Vänligen bekräfta att du är redo att skicka in genom att markera bekräftelsesrutan.',
  generatingPdf: 'Genererar din registrerings-PDF...',
  pdfGenerationError: 'Det uppstod ett fel vid generering av PDF-filen. Försök igen.',
  pdfPreview: 'PDF Förhandsvisning',
  close: 'Stäng',
  download: 'Ladda ner',
  downloadInvoice: 'Ladda ner faktura',
  loading: 'Laddar...',
  downloadInvoiceError: 'Misslyckades att ladda ner fakturan. Försök igen.',
  send: 'Skicka',

  // Fill defaults checkbox
  fillDefaults: 'Fyll med standardvärden',
  fillDefaultsHelp: 'Fyll automatiskt alla obligatoriska fält med exempeldata för testning',
  fillDefaultsSuccess: 'Formuläret fyllt med standardvärden',

  // Email functionality
  sendingEmail: 'Skickar din PDF via e-post...',
  emailSent: 'PDF skickad till registreraforetag@cerneaconsulting.com',
  emailError: 'Fel vid sändning av e-post. Försök igen eller ladda ner PDF:en istället.',

  // PDF Preview
  officialForm: 'Officiellt registreringsformulär',
  downloadingTemplate: 'Laddar ner den officiella formulärmallen...',
  fillingFormData: 'Fyller i din information...',
  templateProcessingError:
    'Kunde inte bearbeta den officiella formulärmallen. Använder reservformat.',

  // Theme
  lightMode: 'Ljust läge',
  darkMode: 'Mörkt läge',

  // Company Basic Info
  companyBasicInformation: 'Grundläggande företagsinformation',
  provideBasicInfo: 'Vänligen ange grundläggande information om ditt företag.',
  companyName: 'Företagsnamn',
  companyNamePlaceholder: 'Ange ditt företagsnamn',
  companyNameHelp: 'Det officiella registrerade namnet på ditt företag',
  registrationNumber: 'Organisationsnummer',
  registrationNumberPlaceholder: 'Ange organisationsnummer',
  registrationNumberHelp: 'Det officiella registreringsnumret utfärdat av myndigheter',
  foundingDate: 'Grundandedatum',
  foundingDateHelp: 'Datumet då ditt företag grundades',
  companyType: 'Företagsform',
  companyTypePlaceholder: 'Välj företagsform',
  companyTypeHelp: 'Den juridiska strukturen för ditt företag',
  llc: 'Aktiebolag',
  corporation: 'Koncern',
  partnership: 'Handelsbolag',
  soleProprietorship: 'Enskild firma',
  nonprofit: 'Ideell förening',
  taxNumber: 'Skatteregistreringsnummer',
  taxNumberPlaceholder: 'Ange skattenummer',
  taxNumberHelp: 'Företagets skatteregistreringsnummer',

  // Address Info
  companyAddress: 'Företagsadress',
  provideAddress: 'Vänligen ange den officiella registrerade adressen för ditt företag.',
  streetAddress: 'Gatuadress',
  streetAddressPlaceholder: 'Ange gatuadress',
  streetAddressHelp: 'Fullständig gatuadress inklusive byggnadsnummer',
  city: 'Stad',
  cityPlaceholder: 'Ange stad',
  stateRegion: 'Stat/Provins/Region',
  stateRegionPlaceholder: 'Ange stat, provins eller region',
  postalCode: 'Postnummer',
  postalCodePlaceholder: 'Ange postnummer',
  country: 'Land',
  countryPlaceholder: 'Välj land',
  unitedStates: 'USA',
  canada: 'Kanada',
  unitedKingdom: 'Storbritannien',
  germany: 'Tyskland',
  france: 'Frankrike',
  sweden: 'Sverige',
  other: 'Annat',

  // Contact Info
  contactInformation: 'Kontaktinformation',
  provideContact: 'Vänligen ange primära kontaktuppgifter för ditt företag.',
  primaryContactName: 'Primär kontaktperson',
  contactNamePlaceholder: 'Ange fullständigt namn',
  contactNameHelp: 'Primär person att kontakta för förfrågningar',
  phoneNumber: 'Telefonnummer',
  phonePlaceholder: 'Ange telefonnummer',
  phoneHelp: 'Format: +[landskod] [nummer]',
  emailAddress: 'E-postadress',
  emailPlaceholder: 'Ange e-postadress',
  companyWebsite: 'Företagswebbplats',
  websitePlaceholder: 'https://www.exempel.se',
  socialMedia: 'Sociala medieprofiler',
  socialMediaPlaceholder: 'Lista ditt företags konton på sociala medier (en per rad)',
  socialMediaHelp: 'LinkedIn, Twitter, Facebook, etc.',

  // Business Info
  businessDetailsTitle: 'Verksamhetsdetaljer',
  provideBusinessInfo: 'Vänligen ge information om din affärsverksamhet.',
  industry: 'Bransch',
  industryPlaceholder: 'Välj din bransch',
  technology: 'Teknik',
  manufacturing: 'Tillverkning',
  retail: 'Detaljhandel',
  healthcare: 'Sjukvård',
  financialServices: 'Finansiella tjänster',
  education: 'Utbildning',
  numberOfEmployees: 'Antal anställda',
  employeesPlaceholder: 'Välj intervall för anställda',
  annualRevenue: 'Årlig omsättning',
  revenuePlaceholder: 'Välj omsättningsintervall',
  lessAmount: 'Mindre än 1 000 000 kr',
  amount100k: '1 000 000 kr - 5 000 000 kr',
  amount500k: '5 000 000 kr - 10 000 000 kr',
  amount1m: '10 000 000 kr - 100 000 000 kr',
  amount10m: '100 000 000 kr+',
  businessDescription: 'Verksamhetsbeskrivning',
  descriptionPlaceholder: 'Beskriv din affärsverksamhet och tjänster',
  descriptionHelp: 'Minst 50 tecken som beskriver din affärsverksamhet',
  registeredCapital: 'Registrerat kapital',
  capitalPlaceholder: 'Ange belopp i SEK',
  capitalHelp: 'Beloppet av kapital registrerat hos myndigheter (t.ex. 100 000,00 kr)',

  // Confirmation
  reviewAndConfirm: 'Granska och bekräfta',
  reviewPrompt: 'Vänligen granska all angiven information och bekräfta att den är korrekt.',
  legalAgreements: 'Juridiska avtal',
  acceptTerms: 'Jag accepterar villkoren',
  termsHelp: 'Genom att markera denna ruta bekräftar jag att jag har läst och godkänner villkoren.',
  acceptPrivacy: 'Jag accepterar integritetspolicyn',
  privacyHelp:
    'Genom att markera denna ruta bekräftar jag att jag har läst och godkänner integritetspolicyn.',
  confirmComplete: 'Jag bekräftar att all information är komplett och korrekt',
  completeHelp:
    'Genom att markera denna ruta intygar jag att all information som angetts är sann och korrekt.',
  readyToSubmit: 'Jag är redo att skicka in min registrering',
  submitHelp:
    'Genom att markera denna ruta bekräftar jag att jag är redo att skicka in detta registreringsformulär.',
  digitalSignature: 'Digital signatur',
  signaturePlaceholder: 'Ditt fullständiga namn',
  signatureHelp:
    'Genom att skriva ditt namn godkänner du att detta utgör en juridisk digital signatur.',

  // PDF Pricing and Terms Dialog
  pdfPricingInfo:
    'Det officiella PDF-registreringsdokumentet kommer att genereras med en behandlingsavgift på 399 SEK ex. moms. Detta inkluderar alla nödvändiga formulär och officiell dokumentation som krävs för bolagsregistrering.',
  termsDialogTitle: 'Villkor och bestämmelser',
  termsDialogContent:
    'Genom att acceptera dessa villkor och bestämmelser godkänner du följande: 1) All information som lämnats är korrekt och fullständig. 2) Du förstår de juridiska kraven för bolagsregistrering. 3) Du godkänner att betala tillhörande avgifter för behandling och dokumentation. 4) Du erkänner att falsk information kan resultera i att din ansökan avvisas. 5) All persondata kommer att behandlas enligt GDPR-reglerna och vår integritetspolicy.',

  // Delivery Email
  deliveryEmailLabel: 'E-postadress för dokumentleverans',
  deliveryEmailPlaceholder: 'Ange e-postadress dit dokumenten ska skickas',
  deliveryEmailHelp: 'Hit kommer de färdiga registreringsdokumenten att skickas',

  // Other Info Text
  otherInfoTextLabel: 'Ytterligare information för e-post',
  otherInfoTextPlaceholder:
    'Ange eventuell ytterligare information som ska inkluderas direkt i e-posttexten...',
  otherInfoTextHelp:
    'Denna text kommer att skickas direkt i e-postmeddelandet, inte inkluderas i PDF-dokumentet',

  // Validation Messages
  fieldRequired: 'Detta fält är obligatoriskt',
  nameMinLength: 'Företagsnamnet måste vara minst 3 tecken',
  nameMaxLength: 'Företagsnamnet måste vara mindre än 100 tecken',
  contactNameMinLength: 'Kontaktnamnet måste vara minst 3 tecken',
  addressMinLength: 'Gatuadressen måste vara minst 5 tecken',
  invalidCity: 'Staden ska endast innehålla bokstäver, mellanslag och bindestreck',
  invalidPostalCode: 'Ogiltigt postnummerformat',
  invalidPhone: 'Ogiltigt telefonnummerformat',
  invalidEmail: 'Ogiltig e-postadress',
  invalidWebsite: 'Ogiltig webbadress',
  descriptionMinLength: 'Verksamhetsbeskrivningen måste vara minst 50 tecken',
  invalidMonetary: 'Ogiltigt monetärt format',
  futureDateError: 'Grundandedatum kan inte vara i framtiden',
  invalidRegNumber: 'Organisationsnummer kan endast innehålla bokstäver, siffror och bindestreck',
  invalidTaxNumber: 'Skattenummer kan endast innehålla bokstäver, siffror och bindestreck',

  // Language Selection
  language: 'Språk',
  english: 'Engelska',
  swedish: 'Svenska',

  // Contact Person
  contactPersonTitle: 'Kontaktperson',
  contactPersonDesc:
    'Kontaktpersonen är beställare och den som vi skickar kontrakt och andra dokument till. Det behöver inte vara samma person som köparen av lagerbolaget.',
  registeredIn: 'Folkbokförd i',
  personalId: 'Personnummer (ÅÅÅÅMMDD-XXXX)',
  citizenshipOtherCountry: 'Medborgarskap i något annat land?',
  specifyCountries: 'Ange vilka länder det gäller',
  firstName: 'Förnamn',
  lastName: 'Efternamn',
  companyOrderer: 'Företagsnamn (om beställaren är ett företag)',
  companyOrdererHelp:
    'Fyll enbart i detta om kontaktpersonen finns på ett företag och vi ska skicka posten dit.',
  careOf: 'c/o',
  phoneRequired: 'Telefonnummer måste anges',
  mobile: 'Mobil',

  // Beskrivningar och nya etiketter för guider
  companyInformationDesc: 'Bolagsuppgifter',
  financialYearDesc: 'Räkenskapsår',
  financialYearStart: 'Räkenskapsår start',
  financialYearEnd: 'Räkenskapsår slut',

  // Financial Year Page - Swedish specific
  financialYearTitle: 'Räkenskapsår',
  financialYearDescription:
    'Ange önskat räkenskapsår. För de allra flesta passar kalenderår (1 januari - 31 december) bäst. För de som har andra krav går det här att välja valfritt räkenskapsår:',
  financialYearStandard1: '1 januari - 31 december',
  financialYearStandard2: '1 maj - 30 april',
  financialYearStandard3: '1 juli - 30 juni',
  financialYearStandard4: '1 september - 31 augusti',
  financialYearSpecial: 'Special räkenskapsår (+895 kr)',
  financialYearCustomLabel: 'Välj annat räkenskapsår',
  financialYearCustom1: '1 februari - 31 januari',
  financialYearCustom2: '1 mars - 28/29 februari',
  financialYearCustom3: '1 april - 31 mars',
  financialYearCustom4: '1 juni - 31 maj',
  financialYearCustom5: '1 augusti - 31 juli',
  financialYearCustom6: '1 oktober - 30 september',
  financialYearCustom7: '1 november - 31 oktober',
  financialYearCustom8: '1 december - 30 november',
  financialYearNotice:
    'Observera: Ditt önskade räkenskapsår finns inte i lager och kommer att beställas. Det innebär att handläggningstiden blir längre än normalt.',
  representativesDesc: 'Företrädare',
  ceo: 'VD',
  boardMembersLabel: 'Styrelseledamöter (en per rad)',

  // Share Capital
  shareCapitalTitle: 'Aktiekapital',
  shareCapitalDescription:
    'Vi lagerhåller bolag med 25 000 kr och 50 000 kr i aktiekapital. Önskas annat aktiekapital än så, kryssa i nyemission nedan. Nyemission kan exempelvis användas för att tre ägare ska få lika stor andel av bolaget.',
  shareCapital25k: '25 000 kr - (250 aktier)',
  shareCapital50k: '50 000 kr - (500 aktier)',
  orderHigherCapital: 'Beställ högre aktiekapital, nyemission (+695 kr)',
  orderShareSplit: 'Beställ högre antal aktier, aktiesplit (+395 kr)',

  // Owners and Representatives
  ownersAndRepresentatives: 'Ägare och Företrädare',
  ownersDescription:
    'Här lägger ni till vem som ska äga bolaget, samt bolagets företrädare, såsom styrelseledamot, eventuell VD, osv. Aktieägare och styrelseledamot är oftast samma person men suppleanten kan inte vara samma som ledamoten. Under tabellen anger du vilket aktiekapital som önskas samt hur många aktier.',
  companyNeedsMinimum: 'Ett bolag behöver minst en ägare, en styrelseledamot och en suppleant.',
  roleColumn: 'Roll',
  nameColumn: 'Namn',
  addressColumn: 'Adress',
  changeColumn: 'Ändra',
  removeColumn: 'Ta bort',
  shareholder: 'Aktieägare',
  boardMember: 'Styrelseledamot',
  boardDeputy: 'Styrelsesuppleant',
  addOwnerRepresentative: 'Lägg till ägare / företrädare',
  companySignatureDesc: 'Firmateckning',
  companySignatureTitle: 'Firmateckning',
  companySignatureDescription: 'Ange nedan vem som ska ha rätt att teckna firman.',
  signatureBoard: 'Tecknas av styrelsen',
  signatureCustom: 'Firman tecknas av styrelsen eller enligt följande:',
  signatureDetailsPlaceholder: 'Ange specifika firmateckningsregler...',
  signatureType: 'Firmateckningssätt',
  signatureTypePlaceholder: 'Välj firmateckningssätt',
  signatureSingle: 'Ensam firmatecknare',
  signatureJoint: 'Gemensam firmateckning',
  signatureAnyTwo: 'Vilka två som helst',
  signatoriesLabel: 'Firmatecknare (en per rad)',

  // Contact Section
  contactSection: 'Behöver du hjälp, vänligen kontakta oss:',

  // Add Representative Dialog
  addOwnerRepresentativeTitle: 'Lägg till ägare / företrädare',
  addToLabel: 'Lägg till',
  newPersonPlaceholder: 'Ny person...',
  newPerson: 'Ny person...',
  asRoleLabel: 'som',
  personalDetailsTitle: 'Personuppgifter',
  personalIdFormat: 'Personnummer (12 siffror, ÅÅÅÅMMDD-XXXX)',
  sharesTitle: 'Aktier',
  numberOfSharesLabel: 'Antal aktier',
  ofTotal: 'av totalt',
  cancel: 'Avbryt',
  addButton: 'Lägg till',

  // Role options
  roles: {
    shareholder: 'Aktieägare',
    boardMember: 'Styrelseledamot',
    boardDeputy: 'Styrelsesuppleant',
    ceo: 'VD',
    viceCeo: 'Vice VD',
    externalSignatory: 'Extern Firmatecknare',
    authorizingPerson: 'Delgivningsbar person',
  },

  // Countries
  countries: {
    afghanistan: 'Afghanistan',
    albania: 'Albanien',
    algeria: 'Algeriet',
    andorra: 'Andorra',
    angola: 'Angola',
    antiguaAndBarbuda: 'Antigua och Barbuda',
    argentina: 'Argentina',
    armenia: 'Armenien',
    australia: 'Australien',
    austria: 'Österrike',
    azerbaijan: 'Azerbajdzjan',
    bahamas: 'Bahamas',
    bahrain: 'Bahrain',
    bangladesh: 'Bangladesh',
    barbados: 'Barbados',
    belarus: 'Vitryssland',
    belgium: 'Belgien',
    belize: 'Belize',
    benin: 'Benin',
    bhutan: 'Bhutan',
    bolivia: 'Bolivia',
    bosniaAndHerzegovina: 'Bosnien och Hercegovina',
    botswana: 'Botswana',
    brazil: 'Brasilien',
    brunei: 'Brunei',
    bulgaria: 'Bulgarien',
    burkinaFaso: 'Burkina Faso',
    burundi: 'Burundi',
    caboVerde: 'Kap Verde',
    cambodia: 'Kambodja',
    cameroon: 'Kamerun',
    canada: 'Kanada',
    centralAfricanRepublic: 'Centralafrikanska republiken',
    chad: 'Tchad',
    chile: 'Chile',
    china: 'Kina',
    colombia: 'Colombia',
    comoros: 'Komorerna',
    congo: 'Kongo',
    costaRica: 'Costa Rica',
    coteDIvoire: 'Elfenbenskusten',
    croatia: 'Kroatien',
    cuba: 'Kuba',
    cyprus: 'Cypern',
    czechRepublic: 'Tjeckien',
    democraticRepublicOfTheCongo: 'Demokratiska republiken Kongo',
    denmark: 'Danmark',
    djibouti: 'Djibouti',
    dominica: 'Dominica',
    dominicanRepublic: 'Dominikanska republiken',
    ecuador: 'Ecuador',
    egypt: 'Egypten',
    elSalvador: 'El Salvador',
    equatorialGuinea: 'Ekvatorialguinea',
    eritrea: 'Eritrea',
    estonia: 'Estland',
    eswatini: 'Eswatini',
    ethiopia: 'Etiopien',
    fiji: 'Fiji',
    finland: 'Finland',
    france: 'Frankrike',
    gabon: 'Gabon',
    gambia: 'Gambia',
    georgia: 'Georgien',
    germany: 'Tyskland',
    ghana: 'Ghana',
    greece: 'Grekland',
    grenada: 'Grenada',
    guatemala: 'Guatemala',
    guinea: 'Guinea',
    guineaBissau: 'Guinea-Bissau',
    guyana: 'Guyana',
    haiti: 'Haiti',
    honduras: 'Honduras',
    hungary: 'Ungern',
    iceland: 'Island',
    india: 'Indien',
    indonesia: 'Indonesien',
    iran: 'Iran',
    iraq: 'Irak',
    ireland: 'Irland',
    israel: 'Israel',
    italy: 'Italien',
    jamaica: 'Jamaica',
    japan: 'Japan',
    jordan: 'Jordanien',
    kazakhstan: 'Kazakstan',
    kenya: 'Kenya',
    kiribati: 'Kiribati',
    kuwait: 'Kuwait',
    kyrgyzstan: 'Kirgizistan',
    laos: 'Laos',
    latvia: 'Lettland',
    lebanon: 'Libanon',
    lesotho: 'Lesotho',
    liberia: 'Liberia',
    libya: 'Libyen',
    liechtenstein: 'Liechtenstein',
    lithuania: 'Litauen',
    luxembourg: 'Luxemburg',
    madagascar: 'Madagaskar',
    malawi: 'Malawi',
    malaysia: 'Malaysia',
    maldives: 'Maldiverna',
    mali: 'Mali',
    malta: 'Malta',
    marshallIslands: 'Marshallöarna',
    mauritania: 'Mauretanien',
    mauritius: 'Mauritius',
    mexico: 'Mexiko',
    micronesia: 'Mikronesien',
    moldova: 'Moldavien',
    monaco: 'Monaco',
    mongolia: 'Mongoliet',
    montenegro: 'Montenegro',
    morocco: 'Marocko',
    mozambique: 'Moçambique',
    myanmar: 'Myanmar',
    namibia: 'Namibia',
    nauru: 'Nauru',
    nepal: 'Nepal',
    netherlands: 'Nederländerna',
    newZealand: 'Nya Zeeland',
    nicaragua: 'Nicaragua',
    niger: 'Niger',
    nigeria: 'Nigeria',
    northKorea: 'Nordkorea',
    northMacedonia: 'Nordmakedonien',
    norway: 'Norge',
    oman: 'Oman',
    pakistan: 'Pakistan',
    palau: 'Palau',
    panama: 'Panama',
    papuaNewGuinea: 'Papua Nya Guinea',
    paraguay: 'Paraguay',
    peru: 'Peru',
    philippines: 'Filippinerna',
    poland: 'Polen',
    portugal: 'Portugal',
    qatar: 'Qatar',
    romania: 'Rumänien',
    russia: 'Ryssland',
    rwanda: 'Rwanda',
    saintKittsAndNevis: 'Saint Kitts och Nevis',
    saintLucia: 'Saint Lucia',
    saintVincentAndTheGrenadines: 'Saint Vincent och Grenadinerna',
    samoa: 'Samoa',
    sanMarino: 'San Marino',
    saoTomeAndPrincipe: 'São Tomé och Príncipe',
    saudiArabia: 'Saudiarabien',
    senegal: 'Senegal',
    serbia: 'Serbien',
    seychelles: 'Seychellerna',
    sierraLeone: 'Sierra Leone',
    singapore: 'Singapore',
    slovakia: 'Slovakien',
    slovenia: 'Slovenien',
    solomonIslands: 'Salomonöarna',
    somalia: 'Somalia',
    southAfrica: 'Sydafrika',
    southKorea: 'Sydkorea',
    southSudan: 'Sydsudan',
    spain: 'Spanien',
    sriLanka: 'Sri Lanka',
    sudan: 'Sudan',
    suriname: 'Suriname',
    sweden: 'Sverige',
    switzerland: 'Schweiz',
    syria: 'Syrien',
    taiwan: 'Taiwan',
    tajikistan: 'Tadzjikistan',
    tanzania: 'Tanzania',
    thailand: 'Thailand',
    timorLeste: 'Östtimor',
    togo: 'Togo',
    tonga: 'Tonga',
    trinidadAndTobago: 'Trinidad och Tobago',
    tunisia: 'Tunisien',
    turkey: 'Turkiet',
    turkmenistan: 'Turkmenistan',
    tuvalu: 'Tuvalu',
    uganda: 'Uganda',
    ukraine: 'Ukraina',
    unitedArabEmirates: 'Förenade Arabemiraten',
    unitedKingdom: 'Storbritannien',
    unitedStates: 'USA',
    uruguay: 'Uruguay',
    uzbekistan: 'Uzbekistan',
    vanuatu: 'Vanuatu',
    vaticanCity: 'Vatikanstaten',
    venezuela: 'Venezuela',
    vietnam: 'Vietnam',
    yemen: 'Jemen',
    zambia: 'Zambia',
    zimbabwe: 'Zimbabwe',
  },
};

export default sv;
